import React from "react";
import { IMethod } from "../interfaces/authorities";

export const ServiceMethodsContext = React.createContext<IMethod[]>([]);
